import React from 'react';
import classNames from 'classnames';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import { ParagraphsRenderer } from '../../../components';

import './style.scss';

const NodeOverviewPage = ({ entity, className }) => {
  const classes = classNames(className, 'NodeOverviewPage');
  const node = entity.toJS();
  const title = node.title[0].value;
  const body = node.body[0]?.processed;

  return (
    <article itemType="http://schema.org/WebPage" className={classes}>

      <Container>
        <div className="NodeOverviewPage__hero">
          <h1 itemProp="name">{title}</h1>
          {body ? (
            <WysiwygField
              property="schema:text"
              html={body}
            />
          ) : null}
        </div>
      </Container>

      <ParagraphsRenderer className="NodeOverviewPage__paragraphs" paragraphs={entity.get('field_paragraphs')} />
    </article>
  );
};

export default NodeOverviewPage;
